import { render, staticRenderFns } from "./FrenchWindowDescription.vue?vue&type=template&id=52e0258b&scoped=true"
import script from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
import style0 from "./FrenchWindowDescription.vue?vue&type=style&index=0&id=52e0258b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0258b",
  null
  
)

export default component.exports